<template>
  <el-dialog title="授权" :visible.sync="visible" :close-on-click-modal="false" @opened="openFun">
    <div>
      <div class="displayDiv">
        <div class="tags-container">
          <el-tag
              v-for="tag in multipleSelection"
              :key="tag.id"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)">
            {{ tag.nickName }}
          </el-tag>
        </div>
        <el-button type="success" :loading="isLoading" @click="submitAuthProduct">保存</el-button>
      </div>
      <div class="searchDiv">
        <el-input class="searchInput" v-model="blurry" placeholder="请输入用户名或昵称" clearable></el-input>
        <el-button type="primary" @click="getUserList">查询</el-button>
      </div>
      <el-table
          :data="tableData"
          row-key="id"
          border
          highlight-selection-row
          ref="multipleTable"
          @selection-change="handleSelectionChange">
        <el-table-column type="selection" reserve-selection width="55"></el-table-column>
        <el-table-column label="用户名" prop="username"></el-table-column>
        <el-table-column label="昵称" prop="nickName"></el-table-column>
        <el-table-column label="角色" prop="roles"></el-table-column>
        <el-table-column label="部门" prop="positionsName"></el-table-column>
        <el-table-column label="状态" prop="enabled" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.enabled" type="success" size="mini">启用</el-tag>
            <el-tag v-else type="danger" size="mini">停用</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <pagination :current.sync="params.current" :size.sync="params.size" :total="params.total" @get-list="getUserList"></pagination>
    </div>

  </el-dialog>
</template>

<script>
import Pagination from "../../../components/Pagination.vue";
import {getUserList} from "@/api/sys/user/sysUser";
import {authProduct} from "../../../api/prod/product/product";
import {successMsg} from "@/utils/message";

export default {
  name: "authProduct",
  components: {
    Pagination
  },
  props: {
    authVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    productId: {
      type: Number,
      require: true,
    },
    hasSelectUserList: {
      type: Array,
      require: true,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      isLoading: false,
      tableData: [],
      dialogVisible: false,
      params:{
        blurry: '',
        current: 1,
        size: 10,
        total: 0,
      },
      multipleSelection: [],
      defaultSelection: false
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.authVisible
      },
      set: function (val) {
        this.$emit('update:authVisible', val)
      }
    },
  },
  mounted() {
    this.getUserList()
  },
  watch:{
    hasSelectUserList:{
      handler: function (val) {
        if(val){
          this.multipleSelection = this.tableData.filter(item => {
            return val.find(v=> v.userId===item.id)
          })
        }
      }
    }
  },
  methods: {
    openFun() {
      const selection = this.multipleSelection
      this.toggleSelection()
      this.toggleSelection(selection);
    },
    getUserList() {
      getUserList({...this.params}).then(res => {
        this.tableData = res.records
        this.params.total = res.total
        this.params.current = res.current
        this.params.size = res.size
      })
    },
    submitAuthProduct() {
      let params = {
        productId: this.productId,
        userIdList: this.multipleSelection.map(item => item.id)
      }
      authProduct(params).then(() => {
        successMsg('操作成功')
        this.$emit('get-list')
      })
      this.isLoading = false
      this.visible = false
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleClose(tag) {
      this.$refs.multipleTable.toggleRowSelection(tag)
    }
  }
}
</script>

<style scoped>
.displayDiv {
  display: flex;
  justify-content: space-between; /* 分配空间使两端对齐 */
  align-items: center; /* 垂直居中对齐子元素 */
}

.tags-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行，如果必要的话 */
  gap: 8px; /* 标签之间的间距 */
}

/* 可选：如果你希望标签容器尽可能地扩展以将按钮推到最右边 */
.tags-container {
  flex-grow: 1;
}
</style>